module.exports = __webpack_public_path__ + "img/reelables-r-logo.9ce6379e.svg";